import React from 'react'

// Vendor
import { useDispatch } from 'react-redux'
import uniqueId from 'lodash/uniqueId'

const defaultOptions = {
  kind: 'RCR_ACTION'
}

const useReactorAction = (identifier, options) => {
  const dispatch = useDispatch()
  const action = React.useCallback((payload, callbacks, meta) => ({
    type: `@@reactor/action/${identifier}`,
    meta: {
      status: 'START',
      kind: options?.kind || 'RCR_ACTION',
      identifier: identifier,
      uid: uniqueId('reactor/action/'),
      tag: options?.tag,
      ...meta
    },
    payload,
    callbacks,
  }), [identifier])

  action.actionType = identifier

  return React.useCallback((payload, callbacks, meta) => {
    dispatch(action(payload, callbacks, meta))
  }, [action])
}

export default useReactorAction